require("./lib/ads");

require("./lib/comments");
var paywall = require("./lib/paywall");
setTimeout(() => paywall(11129786), 3000);
var track = require("./lib/tracking");


require("component-responsive-frame/child");